import React, { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  SIDEBAR_LINKS_PLATFORM,
  SIDEBAR_LINKS_SUPERADMIN,
  ROLE,
} from "../constants/constants";
import cookie from "react-cookies";
import { Icons } from "../constants/icon-library";
import { clearUser } from "../features/user/userSlice";
import { upsertSetting } from "../features/settings/settingsSlice";

export default function Sidebar() {
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    cookie.remove("token", { path: "/" });
    dispatch(clearUser());
    dispatch(upsertSetting());
    navigate("/sign-in", { replace: true });
  };

  const handleProfile = () => {
    navigate("/profile", { replace: true });
  };

  useEffect(() => {
    if (window.feather) {
      window.feather.replace();
    }
  }, []);

  if (!user || !user.role) return null;

  const role = user.role;

  let filteredLinks;
  if (role === ROLE.ADMIN) {
    filteredLinks = SIDEBAR_LINKS_SUPERADMIN;
  } else {
    filteredLinks = SIDEBAR_LINKS_PLATFORM;
  }

  return (
    <nav className="navbar navbar-vertical navbar-expand-lg p-0">
      <div
        className="collapse navbar-collapse"
        id="navbarVerticalCollapse"
        style={{ height: "100%" }}
      >
        <div
          className="navbar-vertical-content d-flex flex-column justify-content-between pb-0"
          style={{ height: "100%" }}
        >
          <ul className="navbar-nav flex-column" id="navbarVerticalNav">
            <li className="nav-item">
              <hr className="navbar-vertical-line" />
              {filteredLinks.map((link) => (
                <div key={link.to} className="nav-item-wrapper mb-2">
                  <NavLink
                    to={link.to}
                    className={({ isActive }) =>
                      `nav-link label-1 px-0 ${isActive ? "active" : ""}`
                    }
                    role="button"
                  >
                    <div className="d-flex align-items-center">
                      <span className="nav-link-icon">
                        <i
                          className={`wb ${Icons(
                            link.icon,
                          )} fs-7 me-2 mt-3 align-middle`}
                        ></i>
                      </span>
                      <span className="nav-link-text-wrapper">
                        <span className="nav-link-text">{link.label}</span>
                      </span>
                    </div>
                  </NavLink>
                </div>
              ))}
            </li>
          </ul>
          <ul className="navbar-nav flex-column">
            <li className="nav-item">
              <hr className="navbar-vertical-line" />
              <div key="profile-key" className="nav-item-wrapper mb-2">
                <button
                  className="nav-link btn label-1 px-0 border-0 w-100 text-start"
                  onClick={handleProfile}
                >
                  <div className="d-flex align-items-center">
                    <span className="nav-link-icon">
                      <i
                        className={`wb ${Icons(
                          "user",
                        )} fs-8 me-2 mt-3 align-middle`}
                      ></i>
                    </span>
                    <span className="nav-link-text-wrapper">
                      <span className="nav-link-text">Profile</span>
                    </span>
                  </div>
                </button>
              </div>
              <div key="logout-key" className="nav-item-wrapper mb-2">
                <button
                  className="nav-link btn label-1 px-0 border-0 w-100 text-start"
                  onClick={handleLogout}
                >
                  <div className="d-flex align-items-center">
                    <span className="nav-link-icon">
                      <i
                        className={`wb ${Icons(
                          "logoutUser",
                        )} fs-8 me-2 mt-3 align-middle`}
                      ></i>
                    </span>
                    <span className="nav-link-text-wrapper">
                      <span className="nav-link-text">Sign out</span>
                    </span>
                  </div>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
